import type { ReactNode } from "react";
import { Fragment } from "react";
import type { Shipment } from "api";
import cn from "classnames";
import { routeMode, routeStops } from "./shipments.model";

type RouteStripProps = {
  shipment: Shipment;
  /** Extra classes — the list row adds `pcsh__sum` to sit it under the cells. */
  className?: string;
  /** Anything that follows the last stop on the same line, like the page's ETA. */
  children?: ReactNode;
};

/** `.shipp__route`: origin to destination, dots and line in the mode's colour. */
export const RouteStrip = ({ shipment, className, children }: RouteStripProps) => (
  <div className={cn("shipp__route", className)} data-mode={routeMode(shipment)}>
    {routeStops(shipment).map((stop, index, stops) => (
      <Fragment key={index}>
        <span className={cn("shipp__pt", { "is-done": stop.done })}>
          <i />
          {stop.name}
        </span>
        {index < stops.length - 1 && <span className={cn("shipp__line", { "is-done": stop.done })} />}
      </Fragment>
    ))}
    {children}
  </div>
);
